import { JsonObject } from 'json2typescript';
import { CategoriesResponseInterface } from '../interfaces/categories-response.interface';

@JsonObject('CategoriesResponseModel')
export class CategoriesResponseModel implements CategoriesResponseInterface {
  Id?: string;
  Name?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
